import {
    faAddressCard,
    faCheck,
    faEnvelope,
    faEye,
    faEyeSlash,
    faLock,
    faPhone,
    faSave,
    faTimes,
    faUserEdit,
    faUserTie,
    faWineBottle
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import React, { useRef, useState, useEffect } from "react";
  import { Button,Dropdown,DropdownButton } from "react-bootstrap";
  import axios from "../../../api/axios";
  import useAuth from "../../../hooks/useAuth";
  
  const EditForm = ({refresh,editValue,show}) => {
    const userRef = useRef();
    const errRef = useRef();
    const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
    const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
    const PHONE_REGEX = /[0-9]$/;
    const CUIT_REGEX = /^\d+$/;
    const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const UPDATE_URL = "/users";
    const { auth } = useAuth();
  
    const [pwdDisplay, setPwdDisplay] = useState(false);
    const [pwdVDisplay, setPwdVDisplay] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [sucess,setSuccess]=useState('')
    const [titleDropDown,setTitleDropDown]=useState('Tipo de usuario')
    const [showTambo,setShowTambo]=useState(false)

    const [valid, setValid] = useState({
      message: [],
      state: true,
    });
  
    const [values, setValue] = useState({
      username: "",
      pwd: "",
      email: "",
      phone: "",
      pwdValid: "",
      roles:"",
      nro_tambo:""
    });
    const defaultValues = {
      username: "",
      pwd: "",
      email: "",
      phone: "",
      pwdValid: "",
      roles:"",
      nro_tambo:""
    };

    const changeRole = (e) => {
      setErrMsg([]);
      console.log(e)
      const newValues = { ...values };
      if(e==1){
        newValues["roles"] = true;
        setShowTambo(false)
        setTitleDropDown('Administrador')
      }else{
        newValues["roles"] = false;
        setShowTambo(true)
        setTitleDropDown('Usuario')
      }
      validateValues(newValues);
      setValue(newValues);
    };
  
    const handleValue = (e) => {
      setErrMsg([]);
      const newValues = { ...values };
  
      if (["phone", "cuit","nro_tambo"].includes(e.target.name)) {
        if (PHONE_REGEX.test(e.target.value)) {
          newValues[`${e.target.name}`] = e.target.value;
        }
      } else {
        newValues[`${e.target.name}`] = e.target.value;
      }
      validateValues(newValues);
      setValue({ ...newValues });
    };
  
    const validateValues = (value) => {
      const defaultValid = {
        message: [],
        state: false,
      };
  
      const PHONE_REGEX_LENG = /[0-9]{10,11}$/;
      const CUIT_REGEX_LENG = /[0-9]{11,12}$/;
  
      setValid(defaultValid);
      if (value?.businessname && !USER_REGEX.test(value?.businessname)) {
        defaultValid.state = false;
        defaultValid.message.push(
          "Ingrese un nombre de empresa - largo mínimo 4 letras "
        );
      }
      if(value?.roles === ''){
        defaultValid.state = false;
        defaultValid.message.push("Seleccione un tipo de usuario del menú desplegable");
      }

      if(value?.nro_tambo === '' && !value.roles){
        defaultValid.state = false;
        defaultValid.message.push("Ingrese un nro. de tambo por favor.");
      }

      if (value?.username && !USER_REGEX.test(value?.username)) {
        defaultValid.state = false;
        defaultValid.message.push("Ingrese un usuario - largo minimo 4 letras");
      }
      if (
        value?.phone &&
        !PHONE_REGEX_LENG.test(value?.phone) &&
        value?.phone.lengh !== 10
      ) {
        defaultValid.state = false;
        defaultValid.message.push(
          "Ingrese un número de teléfono valido por favor - 10 dígitos"
        );
      }
  
      if (value?.email && !EMAIL_REGEX.test(value?.email)) {
        defaultValid.state = false;
        defaultValid.message.push("Ingrese un e-mail valido por favor");
      }
      if (
        value?.cuit &&
        !CUIT_REGEX_LENG.test(value?.cuit) &&
        value?.cuit.lengh !== 11
      ) {
        defaultValid.state = false;
        defaultValid.message.push(
          "Ingrese un número de cuit valido por favor - 11 dígitos"
        );
      }
      if (value?.pwd && !PWD_REGEX.test(value?.pwd)) {
        defaultValid.state = false;
        defaultValid.message.push(
          "Ingrese una contraseña valida por favor - debe contener un nro.,una mayúscula,\n una minuscula,un carácter especial\n 11 dígitos"
        );
      }
      if (value?.pwd && value?.pwd !== value?.pwdValid) {
        defaultValid.state = false;
        defaultValid.message.push(
          "validar que los valores ingresados en ambos campos de contraseña sean idénticos.\n"
        );
      }
      setValid(defaultValid);
      return defaultValid.state;
    };
  
    useEffect(() => {
      userRef.current.focus();
      setValue(editValue);
      setShowTambo(!editValue.roles)
      setTitleDropDown(editValue.roles ? 'Administrador' : 'Usuario')
    }, []);
  
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (valid.message.length > 0) {
        setErrMsg(valid.message);
        errRef.current.focus();
      } else {
        try {
            const response = await axios.put(`${UPDATE_URL}/${editValue.roles === true ? 'moderator/' : ''}${values.id}`,
            JSON.stringify(values),
            {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + auth?.accessToken,
                },
              });
          setValue(defaultValues);
          refresh();
          show(false)
        } catch (err) {
          if (!err?.response) {
            setErrMsg(["No Server Response"]);
          } else if (err.response?.status === 409) {
            setErrMsg(["Username Taken"]);
          } else {
            setErrMsg(["Registration Failed"]);
          }
          errRef.current.focus();
        }
      }
    };
    return (
      <div>
        <p className={sucess ? "bg-green text-white text-center" : "offscreen"}>
          {sucess}
        </p>
        <ul
          ref={errRef}
          className={errMsg.length > 0 ? "errmsg" : "offscreen"}
          aria-live="assertive"
        >
          {errMsg.map((err, key) => (
            <li key={key}>{err}</li>
          ))}
        </ul>
        <form onSubmit={handleSubmit}>
          <label className="form-label my-4 order-md-1">
            Editar Usuario
          </label>
          <div className="col-md-6 order-md-1">
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faUserTie}
              />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Usuario"
              aria-label="usuario"
              autoComplete="off"
              ref={userRef}
              name="username"
              value={values.username}
              onChange={handleValue}
              required
            />
            <DropdownButton
              variant="outline-secondary"
              title={titleDropDown}
              id="input-group-dropdown-2"
              align="end"
              onSelect={changeRole}
            >
              <Dropdown.Item eventKey="1" >Administrador</Dropdown.Item>
              <Dropdown.Item eventKey="2">Usuario</Dropdown.Item>
            </DropdownButton>
          </div>
        </div>
          <div className="col-md-6 order-md-1">
            <div className="input-group mb-3">
              <span className="input-group-text">
                <FontAwesomeIcon
                  style={{ width: "16px", height: "16px" }}
                  icon={faPhone}
                />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Teléfono"
                aria-label="Teléfono"
                maxLength="10"
                autoComplete="off"
                name="phone"
                value={values.phone}
                onChange={handleValue}
                required
                
              />
              <span className="input-group-text">
                <FontAwesomeIcon
                  style={{ width: "16px", height: "16px" }}
                  icon={faEnvelope}
                />
              </span>
              <input
                type="email"
                className="form-control"
                placeholder="E-mail"
                aria-label="E-mail"
                autoComplete="off"
                value={values.email}
                name="email"
                onChange={handleValue}
                required
                
              />
            </div>
          </div>
          {showTambo && <div className="col-md-6 order-md-1">
        <div className="input-group mb-3">
          <span className="input-group-text">
            <FontAwesomeIcon
              style={{ width: "16px", height: "16px" }}
              icon={faWineBottle}
            />
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Nro de Tambo"
            aria-label="Nro de Tambo"
            maxLength="10"
            autoComplete="off"
            name="nro_tambo"
            value={values.nro_tambo}
            onChange={handleValue}
            required
          />
        </div>
      </div>}
          <div className="col-md-6 order-md-1">
            <div className="input-group mb-3">
              <span className="input-group-text">
                <FontAwesomeIcon
                  style={{ width: "16px", height: "16px" }}
                  icon={faLock}
                />
              </span>
              <input
                type={pwdDisplay ? "text" : "password"}
                className="form-control"
                placeholder="Contraseña"
                aria-label="Contraseña"
                autoComplete="off"
                name="pwd"
                value={values.pwd}
                onChange={handleValue}
                required
                
              />
              <Button
                variant="outline-secondary"
                id="button-pwdDisplay"
                onClick={(e) => {
                  e.preventDefault();
                  setPwdDisplay(!pwdDisplay);
                }}
              >
                <FontAwesomeIcon
                  style={{ width: "16px", height: "16px" }}
                  icon={pwdDisplay ? faEyeSlash : faEye}
                />
              </Button>
            </div>
          </div>
          <div className="col-md-6 order-md-1">
            <div className="input-group mb-3">
              <span className="input-group-text">
                <FontAwesomeIcon
                  style={{ width: "16px", height: "16px" }}
                  icon={faLock}
                />
              </span>
              <input
                type={pwdVDisplay ? "text" : "password"}
                className="form-control"
                placeholder="Confirmar Contraseña"
                aria-label="Contraseña"
                autoComplete="off"
                name="pwdValid"
                value={values.pwdValid}
                onChange={handleValue}
                required
              />
              <Button
                variant="outline-secondary"
                id="button-pwdDisplay"
                onClick={(e) => {
                  e.preventDefault();
                  setPwdVDisplay(!pwdVDisplay);
                }}
              >
                <FontAwesomeIcon
                  style={{ width: "16px", height: "16px" }}
                  icon={pwdVDisplay ? faEyeSlash : faEye}
                />
              </Button>
            </div>
          </div>
          <div className="col-md-6 order-md-1">
            <button type="submit" className="btn btn-success mt-4 me-3">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faSave}
              />
            </button>
            <button type="submit" className="btn btn-danger mt-4 me-3" onClick={()=>show(false)}>
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faTimes}
              />
            </button>
          </div>
        </form>
      </div>
    );
  };
  
  EditForm.props={
      editValue:{
        businessname: "",
        username: "",
        pwd: "",
        email: "",
        phone: "",
        cuit: "",
        pwdValid: "",
      }
  }
  export default EditForm;
  
